import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/Shared";
import { resolveLegacyPath } from "../data/redirects";

export default function NotFound() {
  const { pathname } = useLocation();
  const legacyTarget = resolveLegacyPath(pathname);
  if (legacyTarget) return <Navigate to={legacyTarget} replace />;

  const links = [
    { to: "/", label: "Homepage" },
    { to: "/classes", label: "Programs & Classes" },
    { to: "/schedule", label: "Class Schedule" },
    { to: "/get-started", label: "Book a Free Goal Review" },
  ];

  return (
    <>
      <Seo
        title="Page Not Found | Boston Iron Grit"
        description="The page you're looking for doesn't exist. Find our programs, schedule and pricing at Boston Iron Grit in West Roxbury."
        noindex
      />
      <section className="relative min-h-[70vh] bg-[#0A0A0B] flex items-center" data-testid="not-found-page">
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
          <Reveal>
            <Compass size={40} className="text-[#9D0423] mx-auto" />
            <p className="mt-6 font-heading font-extrabold text-7xl text-white/10">404</p>
            <h1 className="mt-2 font-heading font-extrabold uppercase text-4xl sm:text-5xl text-white tracking-tight">
              Page not <span className="text-[#9D0423]">found.</span>
            </h1>
            <p className="mt-5 text-neutral-400 text-base leading-relaxed max-w-md mx-auto">
              That page doesn't exist — it may have moved when we rebuilt the site. Here's where you probably want to go:
            </p>
            <div className="mt-9 flex flex-wrap justify-center gap-3">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`notfound-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="inline-flex items-center gap-2 border border-white/15 hover:border-[#9D0423] text-white font-mono text-[12px] uppercase tracking-[0.14em] px-5 py-3.5 transition-colors"
                >
                  {l.label} <ArrowRight size={13} className="text-[#9D0423]" />
                </Link>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
